<template>

    <div class="contact">
        <single-post v-bind:post="post"></single-post>
        <hr/>

        <div class="contact-form">
            <form @submit.prevent="submit">

                <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                        <div class="form-group { 'form-group--error': $v.yourfirstname.$error }">
                            <label class="form__label"
                                   for="yourfirstname">
                                Voornaam</label>
                            <div class="input-plus-error-message">
                                <input type="text"
                                       v-model="yourfirstname"
                                       id="yourfirstname"
                                       name="yourfirstname"
                                       class="form-control form__input"
                                       v-bind:class="{ redzone: $v.yourfirstname.$error}"
                                       v-model.trim="$v.yourfirstname.$model">
                                <p class="validatie-error"
                                   v-if="$v.yourfirstname.$error"
                                >Dit is een verplicht veld. Vul minimaal een voornaam van twee letters in.</p>
                            </div>

                        </div>
                    <div class="form-group { 'form-group--error': $v.yourlastname.$error }">
                        <label class="form__label"
                               for="yourlastname">
                            Achternaam</label>
                        <div class="input-plus-error-message">
                            <input type="text"
                                   v-model="yourlastname"
                                   id="yourlastname"
                                   name="yourlastname"
                                   class="form-control form__input"
                                   v-bind:class="{ redzone: $v.yourlastname.$error}"
                                   v-model.trim="$v.yourlastname.$model">
                            <p class="validatie-error"
                               v-if="$v.yourlastname.$error"
                            >Dit is een verplicht veld. Vul minimaal een achternaam van twee letters in.</p>
                        </div>

                    </div>
                    <div class="form-group { 'form-group--error': $v.yourcompanyname.$error }">
                        <label class="form__label"
                               for="yourcompanyname">
                            Bedrijfsnaam</label>
                        <div class="input-plus-error-message">
                            <input type="text"
                                   v-model="yourcompanyname"
                                   id="yourcompanyname"
                                   name="yourcompanyname"
                                   class="form-control form__input"
                                   v-bind:class="{ redzone: $v.yourcompanyname.$error}"
                                   v-model.trim="$v.yourcompanyname.$model">
                            <p class="validatie-error"
                               v-if="$v.yourcompanyname.$error"
                            >Dit is een verplicht veld. Vul minimaal een bedrijfsnaam van twee letters in.</p>
                        </div>

                    </div>

                    <div class="form-group { 'form-group--error': $v.yourphonenumber.$error }">
                        <label class="form__label"
                               for="yourphonenumber">
                            Telefoon</label>
                        <div class="input-plus-error-message">
                            <input type="text"
                                   v-model="yourphonenumber"
                                   id="yourphonenumber"
                                   name="yourphonenumber"
                                   class="form-control form__input"
                                   v-bind:class="{ redzone: $v.yourphonenumber.$error}"
                                   v-model.trim="$v.yourphonenumber.$model">
                            <p class="validatie-error"
                               v-if="$v.yourphonenumber.$error"
                            >Dit is een verplicht veld, vul een geldig Nederlands telefoonnummer in. Gebruik dit formaat: 0612345678</p>
                        </div>

                    </div>
                    <div class="form-group { 'form-group--error': $v.youremail.$error }">
                        <label class="form__label"
                               for="youremail">
                            E-mailadres</label>
                        <div class="input-plus-error-message">
                            <input type="text"
                                   v-model="youremail"
                                   id="youremail"
                                   name="youremail"
                                   class="form-control form__input"
                                   v-bind:class="{ redzone: $v.youremail.$error}"
                                   v-model.trim="$v.youremail.$model">
                            <p class="validatie-error"
                               v-if="$v.youremail.$error"
                            >Dit is een verplicht veld, vul een geldig e-mailadres in</p>
                        </div>



                    </div>



                </div>
                <div class="col-12 col-sm-12 col-md-12">
                    <div class="form-group { 'form-group--error': $v.yourmessage.$error }">
                        <label class="form__label"
                               for="yourmessage">Uw bericht</label>
                        <div class="input-plus-error-message">
                        <textarea   type="text"
                                  v-model="yourmessage"
                                  id="yourmessage"
                                  name="yourmessage"
                                  class="form-control form__input"
                                  v-bind:class="{ redzone: $v.yourmessage.$error}"
                                  v-model.trim="$v.yourmessage.$model">

                </textarea>
                            <p class="validatie-error"
                               v-if="$v.yourmessage.$error"
                            >Dit is een verplicht veld, vul een bericht van minimaal 10 karakters in.</p>
                        </div>
                        <div class="contact-Button">
                            <button v-on:click="submit" class="btn btn-primary cropblue">Verzenden</button>
                        </div>
                        <hr />
                    </div>

                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2445.1183918329766!2d4.625526951863791!3d52.204895979656456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c5c34adb3a774d%3A0x8a9d58a90c588452!2sYoursource%20B.V.!5e0!3m2!1sen!2snl!4v1581696923760!5m2!1sen!2snl" width="100%" height="320" frameborder="0" style="border:0;" allowfullscreen=""></iframe>

                </div>
                </div>

                <div class="row">
                    <div class="col-12 ">


                    </div>
                </div>

            </form>

        </div>



    </div>
</template>

<script>
    import axios from 'axios'
    import SinglePost from '../global/SinglePost.vue'
    import {required, minLength, email, integer} from 'vuelidate/lib/validators'


    export default {
        name: 'Page',
        data() {
            return {
                title: '',
                post: [],
                yourfirstname: '',
                yourlastname: '',
                yourcompanyname: '',
                yourphonenumber: '',
                youremail: '',
                yourmessage: '',
                submitStatus: null
            }
        },
        validations: {
            yourfirstname: {
                required,
                minLength: minLength(2)
            },
            yourlastname: {
                required,
                minLength: minLength(2)
            },
            yourcompanyname: {
                required,
                minLength: minLength(2)
            },
            yourphonenumber: {
                required,
                integer,
                minLength: minLength(10)
                // TODO nl telefoonnummer regex validatie
            },
            youremail: {
                required,
                email
            },
            yourmessage: {
                required,
                minLength: minLength(10)
            },

        },

        metaInfo: function() {
            return {
                title: "Yoursource" + " - Contact.",
                meta: [
                    {
                        name: 'description', content: "uw partner op het gebied van bedrijfsadvisering en automatisering.",
                    },
                    {
                        name: 'keywords', content: "Yoursource, Exact, Software, Orbis, Crm, Hrm, Microsoft"
                    }
                ]
            }
        },

        created() {
            this.getPost()
            document.title = this.title
        },

        methods: {
            getPost() {
                var path = this.$route.path
                axios.get(this.apiUrl + '/wp-json/wp/v2/pages/?slug=' + path.replace(/^\/|\/$/g, ''))
                    .then(response => {
                        this.post = response.data[0]
                        if (this.post === undefined) {
                            this.$router.push({name: 'NotFound'})
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            submit() {
                console.log('submit!')
                this.$v.$touch()
                if (this.$v.$invalid) {
                    this.submitStatus = 'ERROR'
                } else {
                    this.sendForm();
                    this.submitStatus = 'PENDING'
                    setTimeout(() => {
                        this.submitStatus = 'OK'
                    }, 500)
                }
            },
            sendForm() {

                /* set body data format, before sending */
                let bodyFormData = new FormData();
                bodyFormData.set('yourfirstname', this.yourfirstname);
                bodyFormData.append('yourlastname', this.yourlastname);
                bodyFormData.append('yourcompanyname', this.yourcompanyname);
                bodyFormData.append('yourphonenumber', this.yourphonenumber);
                bodyFormData.append('youremail', this.youremail);
                bodyFormData.append('yourmessage', this.yourmessage);

                axios.post(this.apiUrl + '/wp-json/contact-form-7/v1/contact-forms/19/feedback',
                    bodyFormData,
                    {})

                    .then(response => {
                        console.log(JSON.stringify(response.data));
                        console.log('Success --> ' + response.data);
                    })
                    .catch(error => {
                        console.log(response.status);
                        // console.log(response.headers);
                        console.log('Error --> ' + error)
                    })
                return false;
            }
        },

        components: {
            'single-post': SinglePost
        }
    }
</script>